import React, { useState, useEffect } from "react";
import CreateIcon from '@material-ui/icons/Create';
import DescriptionIcon from '@material-ui/icons/Description';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

import '../styles/Widget.css';
import RequestHelper from "../utils/RequestHelper";
import Config from "../Config";
import { isOauth, isBasicAuth, ADOxxLogout } from "./oauth/OAuth";
import StateGlobal from "../StateGlobal";
import Commons from "../utils/Commons";
import { reject } from "lodash";

const ModeSelection = (props) =>
{
  const [modeChosen, setModeChosen] = useState(0);
  const [displayError, setDisplayError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("Cannot perform selection!");
  const [loggingOut, setLoggingOut] = useState(false);
  const [repoIsSelected, setRepoIsSelected] = useState(false);

  useEffect(() =>
  {
    setModeChosen(0);
    if (!props.isBasicAuth)
    {
      setErrorMessage("OAuth is not supported yet! You cannot perform any action!");
      setDisplayError(true);
    }
  }, [props.isBasicAuth]);

  const setMode = (nMode) =>
  {
    if (typeof nMode === "number")
    {
      props.modeSetCallback(nMode);
    }
  };

  const logout = async () =>
  {
    if (isOauth())
    {
      ADOxxLogout();
    }

    if (isBasicAuth())
    {
      setLoggingOut(true);
      if (localStorage["gateway_token"])
      {
        try
        {
          const aData = await RequestHelper.sendRequestSimple({
            request: Config.requestSessionLogout,
            dataType: "text",
          });
          if (!aData.isErr)
          {
            console.log("User logged out");
            localStorage.removeItem("user_name");
            window.location.reload();
          }
        } catch (aEx)
        {
          setLoggingOut(false);
          console.error(aEx.message);
        }
      }
      localStorage.removeItem("gateway_token");
    }
  };

  const isRepoSelected = () =>
  {

    const sSelectedRepositoryId = localStorage.getItem("repository_id");

    return new Promise((resolve, reject) =>
    {
      Commons.getAnpRepo()
        .then(() =>
        {
          if (Config.reposAvailable && Config.reposAvailable.length)
          {
            let nSelectedIndex = 0;
            if (sSelectedRepositoryId)
            {
              nSelectedIndex = Config.reposAvailable.findIndex((aItem) => aItem && aItem.id === sSelectedRepositoryId);
            }

            resolve(nSelectedIndex === -1 ? false : true);

          }
        })
        .catch((aEx) => { 
          reject('Failed to load list of repositories')
        });
    })

  }

  useEffect(() =>
  {
    isRepoSelected()
      .then((data) =>
      {
        localStorage.getItem("repository_id") && setRepoIsSelected(data);
        setDisplayError(false)
      })
      .catch((aEx) =>
      {
        setDisplayError(true)
        setErrorMessage(Config.strings.errorMessages.repository.loadError)
        console.error("Load Repositories error: ",aEx); //aEx reject message
      });

  }, [repoIsSelected])
  

  useEffect(() =>
  {
    function result(event)
    {
      setRepoIsSelected(true);
    }

    function addEventListenerSelectedRepo()
    {
      document.addEventListener('selectRepo', result);
    }

    addEventListenerSelectedRepo();
  }, [])

  return (
    <div className="wrcWidget">
      {displayError && <h4 className="App__errorMessage">{errorMessage}</h4>}
      <h2 className="ms-font-l ms-fontWeight-semilight ms-fontColor-neutralPrimary ms-u-slideUpIn20 wrcWidget__label">
        {props.message}
      </h2>
      <div
        className="wrcButton wrcButton--lightGrey wrcButton--big wrcButton--center wrcButton--sectioned"
        data-mode="1"
        style={{
          opacity: repoIsSelected ? "1" : "0.75",
          cursor: repoIsSelected ? "" : "not-allowed"
        }}
        onClick={(aClickEvent) =>
        {

          repoIsSelected && setMode(1);
        }}
      >
        <div className="wrcButton__icon-section wrcButton--darkLight">
          <CreateIcon style={{ fontSize: 16, margin: "auto" }} />
        </div>
        <div className="wrcButton__text-section">
          {/* todo */}
          {Config.strings.modeSelection.buttons.createTemplate}
        </div>
      </div>
      <div
        className="wrcButton wrcButton--lightGrey wrcButton--big wrcButton--center wrcButton--sectioned"
        data-mode="2"
        style={{
          opacity: repoIsSelected ? "1" : "0.75",
          cursor: repoIsSelected ? "" : "not-allowed"
        }}
        onClick={(aClickEvent) =>
        {
          repoIsSelected && setMode(2);
        }}
      >
        <div className="wrcButton__icon-section wrcButton--darkLight">
          <DescriptionIcon style={{ fontSize: 16, margin: "auto" }} />
        </div>
        <div className="wrcButton__text-section">
          {/* todo */}
          {Config.strings.modeSelection.buttons.generateReport}
        </div>
      </div>
      {!loggingOut ? (
        <div
          className="wrcButton wrcButton--lightGrey wrcButton--big wrcButton--center wrcButton--sectioned"
          onClick={logout}
        >
          <div className="wrcButton__icon-section wrcButton--darkLight">
            <PowerSettingsNewIcon style={{ fontSize: 16, margin: "auto" }} />
          </div>
          <div className="wrcButton__text-section">
            {Config.strings.modeSelection.buttons.logout}
          </div>
        </div>
      ) : (
        <h3 className="App__infoMessage">{Config.strings.messages.modeSelection.logOut}</h3>
      )}
    </div>
  );
};

export default ModeSelection;
